import proofkitFilemakerService from './proofkitFilemakerService.js';

// Obtener el valor de la variable de entorno
const LAYOUT = process.env.REACT_APP_FILEMAKER_LAYOUT_URLS;

// Mostrar advertencia si la variable no está configurada correctamente
if (!LAYOUT || LAYOUT === 'your_filemaker_layout_urls') {
  console.warn('Advertencia: REACT_APP_FILEMAKER_LAYOUT_URLS no está configurado correctamente. Valor actual:', LAYOUT);
}

export const getUrls = async () => {
  try {
    // Verificar que LAYOUT esté definido
    if (!LAYOUT) {
      console.error('Error: REACT_APP_FILEMAKER_LAYOUT_URLS no está definido');
      throw new Error('Configuración de layout no disponible');
    }
    
    const response = await proofkitFilemakerService.getAllRecords(LAYOUT);
    const rows = Array.isArray(response?.data) ? response.data : [];

    if (rows.length === 0) {
      return [];
    }

    return rows.map(item => ({
      ...item.fieldData,
      recordId: item.recordId,
      modId: item.modId
    }));
  } catch (error) {
    console.error('Error al obtener URLs:', error);
    throw error;
  }
};

export const getUrlById = async (recordId) => {
  try {
    // Check if LAYOUT is defined
    if (!LAYOUT) {
      console.warn('Warning: REACT_APP_FILEMAKER_LAYOUT_URLS is not defined');
      return null;
    }
    
    const response = await proofkitFilemakerService.getRecord(LAYOUT, recordId);
    const urlData = response?.data;

    if (!urlData) {
      console.warn('Unexpected API response structure:', response);
      return null;
    }
    
    // Map the response data to the expected format
    return {
      id: urlData.fieldData.id || '',
      recordId: urlData.recordId || '',
      name: urlData.fieldData.name || '',
      type: urlData.fieldData.type || 'landbot',
      customDatacodproducto: urlData.fieldData.customDatacodproducto || '',
      url: urlData.fieldData.url || ''
    };
  } catch (error) {
    console.error('Error fetching URL by ID:', error);
    throw error;
  }
};

export const createUrl = async (urlData) => {
  try {
    // Exclude uuid and id fields as they are likely auto-generated
    const completeFieldData = {
      name: urlData.name || '',
      type: urlData.type || 'landbot',
      customDatacodproducto: urlData.customDatacodproducto || '',
      url: urlData.url || ''
      // Removed uuid and id fields
    };

    console.log('Create URL payload:', { fieldData: completeFieldData });

    return await proofkitFilemakerService.createRecord(LAYOUT, completeFieldData);
  } catch (error) {
    console.error('Error al crear URL:', error);
    throw error;
  }
};

export const updateUrl = async (recordId, urlData) => {
  try {
    // Transform data to match the expected API structure
    // Only include fields that are provided in urlData
    const apiData = {};
    
    if (urlData.name !== undefined) apiData.name = urlData.name;
    if (urlData.type !== undefined) apiData.type = urlData.type;
    if (urlData.customDatacodproducto !== undefined) apiData.customDatacodproducto = urlData.customDatacodproducto;
    if (urlData.url !== undefined) apiData.url = urlData.url;
    
    return await proofkitFilemakerService.updateRecord(LAYOUT, recordId, apiData);
  } catch (error) {
    console.error(`Error al actualizar URL con ID ${recordId}:`, error);
    throw error;
  }
};

export const deleteUrl = async (recordId) => {
  try {
    return await proofkitFilemakerService.deleteRecord(LAYOUT, recordId);
  } catch (error) {
    console.error(`Error al eliminar URL con ID ${recordId}:`, error);
    throw error;
  }
};